<template>
  <div class="card shadow-sm">
    <form id="formItems" class="needs-validation" novalidate>
      <div class="card-header">
        <h3 class="card-title" style="font-size: 20px; font-weight: bold">
          เพิ่มสินค้า
        </h3>
      </div>
      <!-- form -->
      <div class="card-body">
        <!-- -->
        <div class="row mb-5">
          <div class="col-sm-1" />
          <div class="col-sm-11">
            <h3>
              <i class="bi bi-file-earmark-text" style="font-size: 20px"></i>
              รายละเอียดสินค้า
            </h3>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-sm-5">
            <label for="selectMainProduct" class="required form-label col-sm-10"
              >กลุ่มสินค้าหลัก</label
            >
            <select
              class="form-select mb-4"
              v-model="form.selectMainProduct"
              id="validationTooltip01"
              @change="mainProductChange(form.selectMainProduct)"
              required
            >
              <option v-for="item in mainProduct" :key="item" :value="item.id">
                {{ item.main_product_group_code }} |
                {{ item.main_product_group_name }}
              </option>
            </select>
            <div class="invalid-feedback text-end">กรุณาเลือก</div>
          </div>
          <div class="col-sm-5">
            <label
              for="selectSecondaryProduct"
              class="required form-label col-sm-10"
              >กลุ่มสินค้ารอง</label
            >
            <select
              class="form-select mb-4"
              v-model="form.selectSubProduct"
              id="validationTooltip01"
              :style="subProductItem.length < 1 ? 'color: red' : ''"
              required
            >
              <option
                v-for="item in subProductItem"
                :key="item"
                :value="item.id"
              >
                {{ item.sub_product_group_code }} |
                {{ item.sub_product_group_name }}
              </option>

              <option value="" v-if="subProductItem.length < 1">
                {{ textSubPdErr }}
              </option>
            </select>
            <div class="invalid-feedback text-end">กรุณาเลือก</div>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <label for="ProductName" class="required form-label col-sm-10"
            >ชื่อทั่วไป</label
          >
          <div class="col-sm-10">
            <input
              v-model="form.product_name"
              type="text"
              class="form-control mb-4"
              id="ProductName"
              name="ProductName"
              required
            />
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <label for="ProductName" class="required form-label col-sm-10"
            >ชื่อสามัญ</label
          >
          <div class="col-sm-10">
            <input
              v-model="form.product_name_generic"
              type="text"
              class="form-control mb-4"
              id="ProductName"
              name="ProductName"
              required
            />
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <label for="detail" class="form-label col-sm-10">รายละเอียด</label>
          <div class="col-sm-10">
            <input
              v-model="form.product_desc"
              type="text"
              class="form-control mb-4"
              id="detail"
              name="detail"
              :style="
                isSubmit
                  ? 'border-color: #ced4da;padding-right: 0.75rem;background: none;'
                  : ''
              "
            />
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="col-sm-5">
            <label for="barcode" class="form-label required col-sm-10"
              >Barcode</label
            >
            <input
              v-model="form.product_barcode"
              type="text"
              class="form-control mb-4"
              id="barcode"
              name="barcode"
              required
            />
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
          <div class="col-sm-5">
            <label for="barcode" class="form-label required col-sm-10"
              >Barcode 2</label
            >
            <input
              v-model="form.product_barcode2"
              type="text"
              class="form-control mb-4"
              id="barcode"
              name="barcode"
            />
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="col-sm-5">
            <label for="pog" class="form-label col-sm-10">POG</label>
            <input
              v-model="form.product_pog"
              type="text"
              class="form-control mb-4"
              id="pog"
              name="pog"
              :style="
                isSubmit
                  ? 'border-color: #ced4da;padding-right: 0.75rem;background: none;'
                  : ''
              "
            />
          </div>
          <div class="col-sm-5">
            <label for="unit" class="form-label required col-sm-10"
              >หน่วยสินค้า</label
            >
            <div class="position-relative">
              <input
                v-model="form.unit"
                type="text"
                class="form-control mb-4"
                id="unit"
                name="unit"
                placeholder="พิมพ์เพื่อค้นหาหน่วย..."
                @input="filterUnits"
                @focus="showUnitDropdown = true"
                @blur="hideUnitDropdown"
                required
                autocomplete="off"
              />
              <div class="invalid-feedback text-end">กรุณาเลือกหน่วยสินค้า</div>

              <!-- Dropdown สำหรับ autocomplete -->
              <div
                v-if="showUnitDropdown && filteredUnits.length > 0"
                class="dropdown-menu show position-absolute w-100"
                style="max-height: 200px; overflow-y: auto; z-index: 1000"
              >
                <button
                  v-for="unit in filteredUnits"
                  :key="unit.id"
                  type="button"
                  class="dropdown-item"
                  @mousedown="selectUnit(unit)"
                >
                  {{ unit.unit_name }} ({{ unit.unit_code }})
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row d-flex justify-content-center mt-4 mt-md-0 mt-lg-0">
          <label
            for="ProductName"
            class="required form-label col-12 col-md-10 col-lg-10"
            >รูปสินค้า</label
          >
        </div>

        <div class="row mt-4 mt-md-0 mt-lg-0">
          <div class="col-1 col-md-1 col-lg-1"></div>
          <div class="col-10 col-md-3 col-lg-3">
            <div class="card shadow-sm card-upload-prod">
              <i
                v-if="imgShow"
                class="bi bi-x m-0 p-0"
                id="close-btn"
                style="
                  right: 0px;
                  font-size: 30px;
                  position: absolute;
                  color: red;
                  z-index: 1001;
                  cursor: pointer;
                "
                @click="removePicture()"
              ></i>
              <div
                class="card-body d-flex justify-content-center align-items-center"
              >
                <img
                  v-if="imgShow"
                  class="shadow-sm img-prod"
                  alt="Logo"
                  :src="imgShow ? imgShow : ''"
                />

                <div
                  v-if="!imgShow"
                  style="
                    font-size: 50px;
                    font-weight: bold;
                    position: absolute;
                    color: white;
                    z-index: 1001;
                    cursor: pointer;
                  "
                >
                  +
                </div>
                <div v-if="!imgShow" @click="onClickUpload">
                  <i class="bi bi-image-fill icon-upload">
                    <input
                      @change="onFileChange($event)"
                      type="file"
                      id="input-img"
                      style="display: none"
                      accept="image/png, image/jpeg"
                    />
                  </i>
                </div>
              </div>
            </div>
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
        </div> -->

        <hr class="mt-10 mb-8" style="color: LightGrey" />

        <div class="row mb-5">
          <div class="col-sm-1" />
          <div class="col-sm-11">
            <h3>
              <i class="bi bi-cash-coin" style="font-size: 20px"></i> ราคาสินค้า
            </h3>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="col-sm-5">
            <label for="retailPrice" class="required form-label col-sm-10"
              >ราคาทุน</label
            >
            <input
              v-model="form.product_cost_price"
              type="number"
              min="0"
              class="form-control mb-4"
              id="retailPrice"
              name="retailPrice"
              required
            />
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
          <div class="col-sm-5">
            <label for="retailPrice" class="required form-label col-sm-10"
              >ราคาขายส่ง</label
            >
            <input
              v-model="form.product_wholesale_price"
              type="number"
              min="0"
              class="form-control mb-4"
              id="retailPrice"
              name="retailPrice"
              required
            />
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="col-sm-5">
            <label for="retailPrice" class="required form-label col-sm-10"
              >ราคาขายปลีก</label
            >
            <input
              v-model="form.product_retail_price"
              type="number"
              min="0"
              class="form-control mb-4"
              id="retailPrice"
              name="retailPrice"
              required
            />
            <div class="invalid-feedback text-end">กรุณากรอก</div>
          </div>
          <div class="col-sm-5">
            <label for="retailPrice" class="form-label col-sm-10"
              >ราคาโปรโมชั่น</label
            >
            <input
              v-model="form.product_promotion_price"
              type="number"
              min="0"
              class="form-control"
              id="retailPrice"
              name="retailPrice"
              :style="
                isSubmit
                  ? 'border-color: #ced4da;padding-right: 0.75rem;background: none;'
                  : ''
              "
            />
          </div>
        </div>

        <hr class="mt-10 mb-8" style="color: LightGrey" />

        <div class="row mb-5">
          <div class="col-sm-1" />
          <div class="col-sm-11">
            <h3>
              <i class="bi bi-box-seam" style="font-size: 20px"></i> คลังสินค้า
            </h3>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="col-sm-5">
            <label for="min" class="form-label col-sm-10">Min</label>
            <input
              v-model="form.product_min_stock"
              type="number"
              class="form-control mb-4"
              id="min"
              name="min"
              :style="
                isSubmit
                  ? 'border-color: #ced4da;padding-right: 0.75rem;background: none;'
                  : ''
              "
            />
          </div>
          <div class="col-sm-5">
            <label for="max" class="form-label col-sm-10">Max</label>
            <input
              v-model="form.product_max_stock"
              type="number"
              class="form-control mb-4"
              id="Max"
              name="Max"
              :style="
                isSubmit
                  ? 'border-color: #ced4da;padding-right: 0.75rem;background: none;'
                  : ''
              "
            />
          </div>
        </div>

        <div class="row d-flex justify-content-start">
          <div class="col-sm-1" />
          <div class="col-sm-5">
            <label for="min" class="form-label col-sm-10">ยอดยกมา Qty</label>
            <input
              v-model="form.product_bring_qty"
              type="number"
              class="form-control"
              id="min"
              name="min"
              :style="
                isSubmit
                  ? 'border-color: #ced4da;padding-right: 0.75rem;background: none;'
                  : ''
              "
            />
          </div>
        </div>

        <hr class="mt-10 mb-8" style="color: LightGrey" />

        <!-- ส่วนจัดการหน่วยสัมพันธ์สินค้า -->
        <div class="row mb-5">
          <div class="col-sm-1" />
          <div class="col-sm-11">
            <h3>
              <i class="bi bi-arrow-repeat" style="font-size: 20px"></i>
              หน่วยสัมพันธ์สินค้า
            </h3>
            <p class="text-muted small">
              ตั้งค่าหน่วยสัมพันธ์สำหรับสินค้านี้ เช่น 1 กล่อง = 25 แผง
            </p>
          </div>
        </div>

        <div class="row d-flex justify-content-center">
          <div class="col-sm-10">
            <div class="card">
              <div class="card-body text-center text-muted py-4">
                <i class="bi bi-info-circle fs-4"></i>
                <p class="mt-2 mb-0">
                  กรุณาบันทึกสินค้าก่อนเพื่อจัดการหน่วยสัมพันธ์
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="pt-0 mt-0" style="color: LightGrey" />

      <footer class="m-6">
        <div class="card-toolbar row justify-content-center">
          <div class="col-sm-10">
            <button
              type="submit"
              class="btn btn-sm btn-light btn-primary ms-3 me-2"
              style="font-size: 14px; font-weight: bold"
              @click="submit"
              :disabled="loading"
            >
              <div
                v-if="loading"
                class="spinner-grow spinner-grow-sm text-light"
                role="status"
              ></div>
              บันทึก
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              style="font-size: 14px; font-weight: bold"
              @click="cancel"
            >
              ยกเลิก
            </button>
          </div>
        </div>
      </footer>
    </form>

    <AddItem
      :dialogAddItem="dialogAddItem"
      :dataEditItem="dataEditItem"
      @submitAddItem="submitAddItem"
      @closeDialogAddItem="closeDialogAddItem"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";

import whApi from "@/api/warehouse/";
import userApi from "@/api/user/";
import apiConfig from "@/config/api";

import { Decode, Encode } from "@/services";

import AddItem from "../../components/upload/dialogCropImg.vue";

export default {
  components: {
    AddItem,
  },
  setup() {
    document.title = "BELUCA | เพิ่มสินค้า";
  },
  data: () => ({
    loading: false,
    isSubmit: false,

    form: {
      selectMainProduct: "",
      selectSubProduct: "",

      product_name: "",
      product_name_generic: "",
      product_desc: "",
      product_barcode: "",
      product_barcode2: "",
      product_pog: "",
      unit: "",
      unitId: "",
      product_pic: "",
      product_cost_price: "",
      product_wholesale_price: "",
      product_retail_price: "",
      product_promotion_price: "",
      product_min_stock: "",
      product_max_stock: "",
      product_bring_qty: "",
      product_first_bring_qty: "",
      is_cancel: "0",
      status: "1",
      approved_by: "",

      userId: "",

      // หน่วยสัมพันธ์สินค้า
      unitRelations: [],
      id: null, // ID สินค้า (จะถูกตั้งค่าหลังจากสร้างสินค้า)
    },
    ccsSelect: `background-size: 16px 12px;background-position: right 1rem center;background-repeat: no-repeat;background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e")`,

    mainProduct: [],
    subProduct: [],

    subProductItem: [],
    textSubPdErr: "",

    // หน่วยสินค้า
    units: [],
    filteredUnits: [],
    showUnitDropdown: false,

    dialogAddItem: false,
    dataEditItem: "",

    imgName: "",
    imgShow: "",
    fileForCreate: "",
    productId: null,
  }),

  created() {
    this.getMainProduct();
    this.getSubProduct();
    this.getUnits();
  },

  methods: {
    async getMainProduct() {
      let responseData = [];
      const companyId = localStorage.getItem("companyId");
      const companyBranchId = localStorage.getItem("companyBranchId");

      try {
        responseData = await whApi.mainProduct.getAll({
          companyId: companyId,
          companyBranchId: companyBranchId,
        });
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.mainProduct = responseData.data;
        // this.form.selectMainProduct = responseData.data[0].id;
      }
    },
    async getSubProduct() {
      let responseData = [];
      const companyId = localStorage.getItem("companyId");
      const companyBranchId = localStorage.getItem("companyBranchId");

      try {
        responseData = await whApi.subProduct.getAll({
          companyId: companyId,
          companyBranchId: companyBranchId,
        });
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.subProduct = responseData.data;
        // this.form.selectSubProduct = responseData.data[0].id;
      }
    },

    async getUnits() {
      let responseData = [];

      try {
        responseData = await whApi.unit.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.units = responseData.data;
        this.filteredUnits = [...this.units];
      }
    },

    filterUnits() {
      if (!this.form.unit) {
        this.filteredUnits = [...this.units];
        return;
      }

      const searchTerm = this.form.unit.toLowerCase();
      this.filteredUnits = this.units.filter(
        (unit) =>
          unit.unit_name.toLowerCase().includes(searchTerm) ||
          unit.unit_code.toLowerCase().includes(searchTerm)
      );
    },

    selectUnit(unit) {
      this.form.unit = `${unit.unit_name} (${unit.unit_code})`;
      this.form.unitId = unit.id;
      this.showUnitDropdown = false;
    },

    hideUnitDropdown() {
      // Delay การซ่อน dropdown เพื่อให้มีเวลาคลิกเลือก
      setTimeout(() => {
        this.showUnitDropdown = false;
      }, 200);
    },

    async submit() {
      let createResponse = [];

      try {
        await this.validateForm();
        await this.checkFormIsEmpty();

        this.isSubmit = true;

        const userId = Decode.decode(localStorage.getItem("boss"));

        if (this.isValid) {
          this.loading = true;

          this.form = {
            ...this.form,
            product_first_bring_qty: this.form.product_bring_qty,
            mainProductGroupId: this.form.selectMainProduct,
            subProductGroupId: this.form.selectSubProduct,
            product_in_transit: 0,
            companyId: parseInt(localStorage.getItem("companyId")),
            companyBranchId: parseInt(localStorage.getItem("companyBranchId")),
            userId: userId,
          };

          createResponse = await whApi.product.create(this.form);

          // ตรวจสอบว่า response มีค่าหรือไม่
          if (!createResponse) {
            throw new Error("ไม่ได้รับ response จาก API");
          }

          if (createResponse.response_status === "SUCCESS") {
            // ตั้งค่า productId สำหรับ ProductUnitRelationManager
            const productId = createResponse.data.id;
            this.form.id = productId;
            this.productId = productId;

            // บันทึกหน่วยสัมพันธ์หลังจากสร้างสินค้า
            const relationsSaved = await this.saveUnitRelations(productId);

            const resUpload = await this.uploadPic(createResponse.data);

            if (resUpload && relationsSaved) {
              // ตรวจสอบว่ามีข้อมูลหน่วยสัมพันธ์หรือไม่
              const hasUnitRelations =
                this.form.unitRelations && this.form.unitRelations.length > 0;

              if (hasUnitRelations) {
                Swal.fire({
                  icon: "success",
                  title: "เพิ่มสำเร็จ",
                  text: "สินค้าและหน่วยสัมพันธ์ถูกบันทึกเรียบร้อยแล้ว",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.$router.push({
                    path: "/warehouse/WH4",
                    query: {},
                  });
                });
              } else {
                Swal.fire({
                  icon: "success",
                  title: "เพิ่มสำเร็จ",
                  text: "สินค้าถูกสร้างเรียบร้อยแล้ว (ยังไม่มีหน่วยสัมพันธ์)",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.$router.push({
                    path: "/warehouse/WH4",
                    query: {},
                  });
                });
              }
            } else if (resUpload && !relationsSaved) {
              Swal.fire({
                icon: "warning",
                title: "เพิ่มสำเร็จ, แต่บันทึกหน่วยสัมพันธ์ไม่สำเร็จ",
                text: "กรุณาแก้ไขหน่วยสัมพันธ์ในหน้าต่อไป",
                confirmButtonText: "ตกลง",
              }).then(() => {
                this.$router.push({
                  path: "/warehouse/WH4",
                  query: {},
                });
              });
            } else if (!resUpload && relationsSaved) {
              Swal.fire({
                icon: "warning",
                title: "เพิ่มสำเร็จ, แต่อัพโหลดรูปภาพไม่สำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push({
                  path: "/warehouse/WH4",
                  query: {},
                });
              });
            }
            this.loading = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "เพิ่มไม่สำเร็จ !",
              text:
                (createResponse && createResponse.message) ||
                "กรุณาลองใหม่อีกครั้ง",
              showConfirmButton: false,
              timer: 2500,
            });
            this.loading = false;
          }
        }
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการสร้างสินค้า:", error);
        this.loading = false;
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: error.message || "กรุณาลองใหม่อีกครั้ง",
          confirmButtonText: "ตกลง",
        });
      }
    },

    checkFormIsEmpty() {
      !this.form.product_name
        ? (this.isValid = false)
        : !this.form.product_name_generic
        ? (this.isValid = false)
        : !this.form.product_cost_price
        ? (this.isValid = false)
        : !this.form.product_wholesale_price
        ? (this.isValid = false)
        : !this.form.product_retail_price
        ? (this.isValid = false)
        : !this.form.selectMainProduct
        ? (this.isValid = false)
        : !this.form.selectSubProduct
        ? (this.isValid = false)
        : !this.form.product_barcode
        ? (this.isValid = false)
        : !this.form.unitId
        ? (this.isValid = false)
        : (this.isValid = true);
    },
    validateForm() {
      let forms = document.querySelectorAll(".needs-validation");
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            event.preventDefault();
            if (!form.checkValidity()) {
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    cancel() {
      this.$router.push({
        path: "/warehouse/WH4",
        query: {},
      });
    },
    mainProductChange(val) {
      const filterSubProduct = this.subProduct.filter(
        (data) => data.mainProductGroupId === val
      );
      if (filterSubProduct.length > 0) {
        this.subProductItem = filterSubProduct;
        this.form.selectSubProduct = filterSubProduct[0].id;
        this.textSubPdErr = "";
      } else {
        this.textSubPdErr = "ไม่มีกลุ่มสินค้ารอง ภายใต้กลุ่มสินค้าหลักที่เลือก";
        this.subProductItem = [];
        this.form.selectSubProduct = "";
      }
    },

    // product
    addItem(pic) {
      this.dialogAddItem = true;
      this.dataEditItem = pic;
    },

    closeDialogAddItem() {
      this.dialogAddItem = false;
    },

    async submitAddItem(item) {
      console.log(item, 234);
      this.closeDialogAddItem();
      this.imgShow = item.canvas.toDataURL(this.image.type);
      let file = await this.dataURLtoFile(this.imgShow, this.imgName);
      if (file) {
        // this.uploadPic(file);
        this.fileForCreate = file;
      }
    },

    // upload pic
    onClickUpload() {
      document.getElementById("input-img").click();
    },

    async onFileChange(e) {
      const selectImg = e.target.files[0];
      this.imgName = selectImg.name;
      const response = await this.createBase64Img(selectImg);

      if (response) {
        this.image = response;
        this.addItem(response);
      }
    },

    async createBase64Img(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
          resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    },

    async removePicture() {
      this.imgShow = "";
    },

    async dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    async uploadPic(item) {
      try {
        // ตรวจสอบว่ามีไฟล์ที่จะอัพโหลดหรือไม่
        if (!this.fileForCreate) {
          console.log("ไม่มีไฟล์ที่จะอัพโหลด");
          return true; // ไม่มีไฟล์ก็ถือว่าสำเร็จ
        }

        const companyBranchId = localStorage.getItem("companyBranchId");

        const formData = new FormData();
        formData.append("file", this.fileForCreate);
        formData.append("type", "upload-file");
        formData.append("name", this.fileForCreate.name);
        formData.append("size", this.fileForCreate.size);
        formData.append("productId", item.id);

        console.log("เริ่มอัพโหลดรูปภาพ:", {
          fileName: this.fileForCreate.name,
          fileSize: this.fileForCreate.size,
          productId: item.id,
        });

        const response = await userApi.upload.upload(formData);

        // ตรวจสอบว่า response มีค่าหรือไม่
        if (!response) {
          throw new Error("ไม่ได้รับ response จาก API อัพโหลด");
        }

        console.log("Response from upload API:", response);

        if (response.response_status === "SUCCESS") {
          console.log("อัพโหลดรูปภาพสำเร็จ");
          return true;
        } else {
          console.error("อัพโหลดรูปภาพล้มเหลว:", response);
          Swal.fire({
            icon: "error",
            title: `อัพโหลดรูปภาพไม่สำเร็จ`,
            text: response.message || "กรุณาลองใหม่อีกครั้ง",
            confirmButtonText: "ตกลง",
          });
          return false;
        }
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการอัพโหลดรูปภาพ:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการอัพโหลดรูปภาพ",
          text: error.message || "กรุณาลองใหม่อีกครั้ง",
          confirmButtonText: "ตกลง",
        });
        return false;
      }
    },

    // บันทึกหน่วยสัมพันธ์หลังจากสร้างสินค้า
    async saveUnitRelations(productId) {
      console.log("เริ่มบันทึกหน่วยสัมพันธ์ - productId:", productId);
      console.log("unitRelations:", this.form.unitRelations);
      console.log(
        "unitRelations length:",
        this.form.unitRelations ? this.form.unitRelations.length : "undefined"
      );

      // ตรวจสอบว่า unitRelations เป็น Proxy object หรือไม่
      if (
        this.form.unitRelations &&
        this.form.unitRelations.length !== undefined
      ) {
        console.log(
          "unitRelations is Proxy object, length:",
          this.form.unitRelations.length
        );
      }

      if (
        !productId ||
        !this.form.unitRelations ||
        this.form.unitRelations.length === 0
      ) {
        // ตรวจสอบว่าเป็นสินค้าใหม่หรือไม่
        if (!productId) {
          console.log("สินค้าใหม่ - ไม่มี productId");
          console.log("ไม่มีข้อมูลหน่วยสัมพันธ์ที่จะบันทึก");
        } else {
          console.log("สินค้าใหม่ - มี productId แต่ไม่มีข้อมูลหน่วยสัมพันธ์");
          console.log(
            "นี่เป็นเรื่องปกติสำหรับสินค้าใหม่ที่ยังไม่ได้ตั้งค่าหน่วยสัมพันธ์"
          );
          console.log("ไม่จำเป็นต้องบันทึกหน่วยสัมพันธ์สำหรับสินค้าใหม่");
        }

        console.log("productId:", productId);
        console.log("unitRelations exists:", !!this.form.unitRelations);
        console.log(
          "unitRelations length:",
          this.form.unitRelations ? this.form.unitRelations.length : "undefined"
        );

        return true;
      }

      try {
        const relations = this.form.unitRelations.map((relation) => ({
          product_id: productId,
          from_unit_id: relation.from_unit_id,
          to_unit_id: relation.to_unit_id,
          from_quantity: relation.from_quantity,
          to_quantity: relation.to_quantity,
          conversion_factor: relation.conversion_factor,
          price: relation.price || null,
        }));

        const response = await whApi.productUnitRelation.createMultiple({
          relations: relations,
        });

        if (response.success) {
          console.log("บันทึกหน่วยสัมพันธ์สำเร็จ:", response);
          return true;
        } else {
          console.error("บันทึกหน่วยสัมพันธ์ล้มเหลว:", response);
          return false;
        }
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการบันทึกหน่วยสัมพันธ์:", error);
        console.error("Error details:", error.message);
        return false;
      }
    },
  },
};
</script>

<style scoped>
/* Autocomplete dropdown styles */
.position-relative .dropdown-menu {
  border: 1px solid #e4e6ef;
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  margin-top: -4px;
}

.position-relative .dropdown-item {
  padding: 0.5rem 0.75rem;
  border: none;
  background: none;
  text-align: left;
  width: 100%;
  color: #5e6278;
  transition: all 0.15s ease-in-out;
}

.position-relative .dropdown-item:hover {
  background-color: #f5f8fa;
  color: #3f4254;
}

.position-relative .dropdown-item:focus {
  background-color: #f5f8fa;
  color: #3f4254;
  outline: none;
}

/* Custom scrollbar for dropdown */
.position-relative .dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.position-relative .dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.position-relative .dropdown-menu::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 10px;
}

.position-relative .dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
